import { render, staticRenderFns } from "./English-Test-Settings.vue?vue&type=template&id=3ec5053f&"
import script from "./English-Test-Settings.vue?vue&type=script&lang=js&"
export * from "./English-Test-Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports